<template>
  <div class="auth-box">
    <router-link to="/favourite" class="auth-item">
      <i class="fas fa-heart"></i>
      {{ $t('text.favourite') }}
    </router-link>
    <!-- NOT LOGIN -->
    <div class="auth-group" v-if="!isLogin">


      <router-link to="/login" class="auth-item">
        <i class="fa-solid fa-right-to-bracket"></i>
        {{ $t('loginForm.login') }}
      </router-link>

      <router-link to="/registers" class="auth-item">
        <i class="fa-solid fa-user-plus"></i>
        {{ $t('loginForm.register') }}
      </router-link>
    </div>

    <!-- LOGIN -->
    <div class="auth-group" v-else>

      <a-dropdown placement="bottomRight">
        <div class="auth-item user-trigger">
          <a-avatar :size="28" :src="url">
          </a-avatar>
          <span class="username">{{ tagName }}</span>
        </div>

        <template #overlay>
          <a-menu class="user-menu">

            <!-- Header user -->
            <a-menu-item key="user">
              <div class="user-header">
                <a-avatar :size="36" :src="url" />
                <div class="user-info">
                  <div class="name">{{ tagName }}</div>
                </div>
              </div>
            </a-menu-item>

            <a-menu-divider />

            <!-- Change password -->
            <a-menu-item key="changePass" @click="changePassword">
              <i class="fa-solid fa-user-shield"></i>
              {{ $t('text.changePass') }}
            </a-menu-item>

            <!-- Logout -->
            <a-menu-item key="logout" danger @click="logOut">
              <i class="fa-solid fa-arrow-right-from-bracket"></i>
              {{ $t('loginForm.logout') }}
            </a-menu-item>

          </a-menu>
        </template>
      </a-dropdown>
    </div>

  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, computed } from "vue";
import store from "@/store/index";
import { useRouter } from "vue-router";
import commons from "@/utils/Common";
const router = useRouter();
const tagName = ref("");
const url = ref("");

const isNotLogin = ref(false);
const isLogin = ref(false);
const logOut = async () => {
  commons.logOut()
  await loadData()
  router.push({ path: "./" });
};

const isLoadLogin = computed(() => {
  return store.getters.isLoadLogin;
});
const changePassword = async () => {
  router.push({ path: "/password" });
};
onMounted(async () => {
  await loadData()
});

const loadData = () => {
  let user = commons.getUserData();
  if (user != null && user != undefined) {
    tagName.value = user.tagName;
    url.value = user.avatar;
  }
  else {
    isNotLogin.value = true
    isLogin.value = false
  }
  isLogin.value = commons.checkLogin()
}

watch(isLoadLogin, async (newValue, oldValue) => {
  await loadData()
});
</script>
<style scoped>
.ant-dropdown-menu-title-content {
  display: flex !important;
}

.auth-box {
  display: flex;
  align-items: center;
}

.auth-group {
  display: flex;
  align-items: center;
  gap: 14px;
}

.auth-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  color: #aaa;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.auth-item:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

/* user trigger */
.user-trigger {
  padding: 4px 10px;
}

/* username */
.username {
  font-size: 13px;
  font-weight: 500;
}

/* dropdown menu */
.user-menu {
  min-width: 180px;
}

/* header trong dropdown */
.user-header {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: default !important;
}

.user-info .name {
  font-weight: 600;
  font-size: 13px;
}

/* icon */
.auth-item i {
  font-size: 13px;
}

@media (max-width: 767px) {
  .auth-group {
    display: none;
  }
}
</style>